<template>
    <div>
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                v-if="model"
                ref="RkmForm"
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            range
                            :range-inline="false"
                            start-label="Período de"
                            end-label="Até"
                            :start-validations="validations.periodo.date.start"
                            :end-validations="validations.periodo.date.end"
                            :max-date="additionals.dataAtual"
                            v-model="model.periodo.date"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            @change="classificacaoRiscoChange()"
                            :disabled="!isPeriodoFill"
                            :options="form.classificacoesRisco"
                            defaultOptionText="Todas"
                            label="Classificação de risco"
                            show-default-option
                            text-field="nome"
                            v-model="model.classificacaoRiscoId"
                            value-field='id'
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            @change="unidadeChange()"
                            :disabled="!isPeriodoFill"
                            :options="form.unidades"
                            defaultOptionText="Todas"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field='id'
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            :options="form.locaisAtendimento"
                            defaultOptionText="Todos"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.localAtendimentoId"
                            value-field='id'
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col class="flex-grow-0 text-nowrap">
                        <rkm-button
                            :disabled="!isPeriodoFill"
                            :label="false"
                            @click="handleBuscar()"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :disabled="!isPeriodoFill"
                            :label="false"
                            @click="limpar()"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Resultado"
        >
            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    no-caret
                    small
                    title="Colunas"
                    v-rkm-tooltip.hover
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>

                    <rkm-form-checkbox
                        @change="handleSelectedColumns"
                        :indeterminate="indeterminate"
                        class="mx-2"
                    >
                        Todas
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="form && form.columns"
                        class="mx-2"
                        stacked
                        v-model="selectedCols"
                    />
                </rkm-dropdown>

                <rkm-button
                    :disabled="items.length === 0"
                    @click="imprimir()"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="items.length === 0"
                    @click="exportar()"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>

            <rkm-table
                class="mt-4"
                :fields="fields"
                :items="items"
                hide-filters
                hide-pagination
            >
                <template v-slot:cell(procedimento)="row">
                    {{ row.item.procedimentoCodigo | formatProcedimento }} - {{ row.item.procedimentoNome }}
                </template>

                <template v-slot:cell(ocupacao)="row">
                    {{ row.item.ocupacaoCodigo }} - {{ row.item.ocupacaoNome }}
                </template>

                <template #afterTable v-if="items.length > 0">
                    <rkm-row>
                        <rkm-col
                            cols="12"
                            class="total"
                        >
                            Total: {{ totalGeral }}
                        </rkm-col>
                    </rkm-row>
                </template>
            </rkm-table>
        </rkm-area>
    </div>
</template>

<script>
// Filters.
import formats from '@/filters/formats'

// Mixins.
import { repository, error, data, object, stringCase } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        fields() {

            let fields = [
                { key: 'unidade', label: 'Unidade', sortable: true },
            ]

            if (this.form) {

                this.selectedCols.map(map => {

                    const col = this.form.columns.find(find => find.value === map)
                    fields.push({ key: col.value, label: col.text, sortable: true, })
                })
            }

            fields.push(
                { key: 'total', label: 'Total', sortable: true },
            )

            return fields
        },
        validations() {
            return {
                periodo: {
                    date: {
                        start: { required: true },
                        end: { required: true },
                    },
                },
            }
        },
        isPeriodoFill() {
            return this.model.periodo.date.start != null && this.model.periodo.date.end != null
        }
    },
    created() {

        this.repositories = {
            relatorioClassificacaoRisco: this.getConectaSusRepository('prontoAtendimento.relatorioClassificacaoRisco'),
            impressao: this.getConectaSusRepository('impressao.prontoAtendimento'),
            export: this.getConectaSusRepository('exportacao.prontoAtendimento'),
        }

        this.load()
    },
    data: () => ({
        items: [],
        model: null,
        form: null,
        additionals: null,
        indeterminate: false,
        filterDefault: {},
        selectedCols: [],
        totalGeral: 0
    }),
    filters: {
        ...formats,
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleSelectedColumns(selected) {

            if (selected) {

                this.form.columns.map(col => {

                    this.selectedCols.push(col.value)
                })

            } else {

                this.selectedCols = []
            }
        },
        load() {

            this.setLoading()

            this.repositories.relatorioClassificacaoRisco.list()
                .then(({ data }) => {

                    this.form = this.clone(data.form)
                    this.model = this.clone(data.model)
                    this.additionals = this.clone(data.additionals)

                    this.filterDefault = {
                        form: this.clone(this.form),
                        model: this.clone(this.model)
                    }

                    this.addPeriodoWatch()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        addPeriodoWatch() {

            this.$watch('model.periodo', {
                deep: true,
                handler() {

                    this.model.classificacaoRiscoId = null
                    this.model.unidadeId = null
                    this.model.localAtendimentoId = null

                    this.form.classificacoesRisco = []
                    this.form.unidades = []
                    this.form.locaisAtendimento = []

                    const filter = this.getFilter()

                    if (filter) {

                        this.setLoading()

                        this.repositories.relatorioClassificacaoRisco.list(filter)
                            .then(({ data }) => {

                                this.form = this.clone(data.form);
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                }
            })
        },
        handleBuscar() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.items = []

                    this.repositories.relatorioClassificacaoRisco.index(this.getFilter())
                        .then(({ data }) => {

                            this.items = data.classificacoesRisco
                            this.totalGeral = data.totalGeral
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        classificacaoRiscoChange() {

            this.model.unidadeId = null
            this.model.localAtendimentoId = null

            this.form.unidades = []
            this.form.locaisAtendimento = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioClassificacaoRisco.list(filter)
                    .then(({ data }) => {

                        this.form.unidades = this.clone(data.form.unidades)
                        this.form.locaisAtendimento = this.clone(data.form.locaisAtendimento)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        unidadeChange() {

            this.model.localAtendimentoId = null

            this.form.locaisAtendimento = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioClassificacaoRisco.list(filter)
                    .then(({ data }) => {

                        this.form.locaisAtendimento = this.clone(data.form.locaisAtendimento)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        imprimir() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const filter = this.getFilterExportPrint()

                    this.repositories.impressao.relatorioClassificacaoRisco(filter)
                        .then(response => {

                            this.download(response)
                        })
                        .finally(() => this.unsetLoading())
                })
        },
        exportar() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const filter = this.getFilterExportPrint()

                    this.repositories.export.exportClassificacaoRisco(filter)
                        .then(response => {

                            this.download(response)
                        })
                        .finally(() => this.unsetLoading())
                })
        },
        download(response) {

            const content = new Blob([response.data], {type: response.headers['content-type']})
            const url = URL.createObjectURL(content)
            const link = document.createElement('a')

            link.href = url
            link.target = '_blank'
            link.click()
            link.remove()
        },
        getFilterExportPrint() {

            const filter = this.getFilter()
            const $this = this

            const cols = this.fields.map(function (field) {

                field.key = $this.camelToSnake(field.key)

                return field
            })

            filter.columns = cols

            const classificacaoRisco = this.form.classificacoesRisco.find(u => u.id === this.model.classificacaoRiscoId)
            filter.classificacao_risco = classificacaoRisco ? classificacaoRisco.nome : 'Todas'

            const unidade = this.form.unidades.find(u => u.id === this.model.unidadeId)
            filter.unidade = unidade ? unidade.nomeFantasia : 'Todas'

            const localAtendimento = this.form.locaisAtendimento.find(l => l.id === this.model.localAtendimentoId)
            filter.local_atendimento = localAtendimento ? localAtendimento.nome : 'Todos'

            return filter
        },
        getFilter() {

            if (this.isPeriodoFill) {

                const filter = this.clone(this.model)
                filter.periodo.date.start = this.getFormatedDate(filter.periodo.date.start, 'DD/MM/YYYY')
                filter.periodo.date.end = this.getFormatedDate(filter.periodo.date.end, 'DD/MM/YYYY')

                return this.camelObjectKeysToSnakeRecursive(filter)
            }

            return null
        },
        limpar() {

            this.form = this.clone(this.filterDefault.form)
            this.model = this.clone(this.filterDefault.model)
            this.$refs.RkmForm.resetValidator()
        }
    },
    mixins: [ repository, error, data, object, stringCase ],
    watch: {
        'selectedCols': function (newValue) {

            this.indeterminate = false

            if (newValue.length > 0 && newValue.length != this.form.columns.length) {

                this.indeterminate = true
            }
        }
    }
}
</script>

<style scoped>
    .total {
        text-align: right;
        font-weight: bold;
    }
</style>